import { copApi } from 'api'
import { PractitionerME } from 'types/practitioners'

export const fetchMe = () => copApi.get<PractitionerME>('/users/me')
